<template>
  <MasterclassFormBase :isEdit="true" />
</template>

<script setup>
import MasterclassFormBase from "@/components/admin/ysa/MasterclassFormBase.vue";
</script>
